/**
 * JEDEN WYŁĄCZNIK NA WSZYSTKIE BRAMKI LOGOWANIA.
 *
 * ═══ DZIŚ `false` — ZDJĘTE NA PROŚBĘ WŁAŚCICIELA 2026-08-13 ═══
 * Wszystkie treści, które były za logowaniem, są chwilowo otwarte dla każdego.
 * To stan TYMCZASOWY — decyzja brzmiała „zwolnijmy na razie, a jak powiem,
 * że wracamy, niech wróci do obecnego stanu".
 *
 * ═══ JAK PRZYWRÓCIĆ ═══
 * Zmień na `true`. To wszystko — jedna linia, żadnych innych zmian.
 * Miejsca objęte flagą (stan na dzień jej wprowadzenia):
 *
 *   1. Historia cen modelu           — components/PriceHistoryChart.jsx (od 2026-10-19 POZA flagą: bez konta
 *      3 podglądy z licznikiem, lib/limitBezKonta, zadanie FE-09)
 *   2. Dobór zaawansowany w asystencie — components/kits/CategorySection.jsx
 *   3. VoltValue Projekt i schemat + PDF — components/elektryka/ModalSchematu.jsx
 *   4. Lista wykonawców po wyborze województwa — pages/WyborWykonawcy.jsx
 *   5. Formularze partnerskie        — components/auth/BramkaPartnera.jsx
 *
 * Wszystkie pięć przechodzi przez `BramkaTresci` albo przez hak
 * `useDostepDoTresci` z components/auth/BramkaLogowania.jsx, więc flaga
 * obsługuje je z jednego miejsca. Jeśli dokładasz NOWĄ bramkę, użyj tego samego
 * haka zamiast pytać `useAuth()` wprost — inaczej wypadnie spod wyłącznika
 * i przy przywracaniu ktoś ją przeoczy.
 *
 * ═══ CZEGO TA FLAGA NIE ROBI ═══
 * Nie dotyka backendu. Żaden z tych endpointów nie wymagał zalogowania po
 * stronie serwera — bramki były zasłoną w interfejsie, nie kontrolą dostępu
 * (patrz komentarz w BramkaLogowania.jsx). Zgłoszenia partnerskie działają
 * anonimowo, bo `distributors_api` ma `auth=None`, a model zgłoszenia nie ma
 * powiązania z użytkownikiem — sprawdzone przed zdjęciem bramki, żeby otwarty
 * formularz nie kończył się błędem przy wysyłce.
 */
export const BRAMKI_LOGOWANIA_WLACZONE = false

/**
 * Bramki włączone NIEZALEŻNIE od wyłącznika wyżej (decyzje właściciela, każda osobno).
 *
 * `zgloszenieOsd` (2026-10-08): w narzędziu „Zgłoszenie mikroinstalacji” wybór operatora (mapa, kafelki) jest
 * dla każdego, a sprzęt, ocena mocy, wniosek i załączniki po zalogowaniu. Przekazuj klucz do
 * `useDostepDoTresci(klucz)` / `<BramkaTresci bramka=...>`, a nie `useAuth()` wprost.
 *
 * Na localhost (serwer deweloperski, `NODE_ENV=development`) bramka jest zdjęta, żeby sprawdzać narzędzie bez
 * logowania (prośba właściciela 2026-10-09). Build produkcyjny (`production`) i testy (`test`) mają ją włączoną,
 * więc wdrożenie nie wymaga ręcznego przełączania.
 */
// `zawiadomieniePsp` (2026-10-09): ta sama zasada co zgłoszenie do OSD (opis dla każdego, formularz po zalogowaniu).
export const BRAMKI_ZAWSZE = {
  zgloszenieOsd: process.env.NODE_ENV !== 'development',
  zawiadomieniePsp: process.env.NODE_ENV !== 'development',
  // Teczka PME2 (decyzja właściciela 2026-10-09) zapisuje się na koncie, więc bez logowania nie działa
  // także na localhost.
  teczkaPme2: true,
  // Panel „Klienci” (CRM firmy) zapisuje na koncie, więc też zawsze za logowaniem.
  klienci: true,
  // Projekt 3D (decyzja właściciela 2026-10-15): cała strona `/projekt-3d` po zalogowaniu, także na localhost.
  // Tylko zasłona w interfejsie: dane GUGiK i katalog modułów nadal odpowiadają każdemu (właściciel to przyjął).
  // Bramka stoi w pages/Projekt3DBramka.jsx, kłódka przy pozycji w menu z `bramka` w config/nawigacja.js.
  projekt3d: true,
  // Rynek zleceń (decyzja właściciela 2026-10-21): ogłoszenie i „Moje ogłoszenia” tylko z kontem, także na localhost.
  rynek: true,
  // Teczka instalacji (plan 2026-10-23): zapisuje się na koncie, więc tylko z kontem, także na localhost.
  teczka: true,
}

export default BRAMKI_LOGOWANIA_WLACZONE
